export default "__VITE_ASSET__aSFFXzXN__"